<template>
    <span class="status-badge">
        <span v-if="status == 0" class="draft">Draft</span>
        <span v-if="status == 1" class="published">Published</span>
        <span v-if="status == 2" class="archived">Archived</span>
    </span>
</template>
<script>
  export default {
    name: 'status',
    props: ['status']
  }
</script>
<style lang="scss" scoped>
    .status-badge {
        padding: 5px 10px;
        background: #dcdcdc;
        margin-right: 15px;

        .draft {
            color: #1c1c1d;
        }
        .published {
            color: #0a74b7;
        }
        .archived {
            color: #4f4f4f;
        }
    }
</style>


// WEBPACK FOOTER //
// status.vue?2d290d16